import type { CSSProperties, ReactNode } from 'react';

/** Centered section heading (eyebrow + title + optional lead). */
export function SectionHead({ eyebrow, title, sub, children }: { eyebrow: string; title: string; sub?: string; children?: ReactNode }) {
  return (
    <div className="lp-section-head center" data-reveal>
      <span className="eyebrow">{eyebrow}</span>
      <h2 className="h2">{title}</h2>
      {sub ? <p className="lead">{sub}</p> : null}
      {children}
    </div>
  );
}

/** Stagger delay for `[data-reveal]` items. */
export const delay = (ms: number): CSSProperties => ({ '--d': `${ms}ms` } as CSSProperties);
